import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getOrganizationDetails = () => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING_ORAGANIZATION" });
  try {
    const { data } = await auction.get(`/profile/read/organization`);
    dispatch({ type: "HIDE_LOADING_ORAGANIZATION" });
    dispatch({ type: "GET_ORAGANIZATION_AUCTION", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_LOADING_ORAGANIZATION" });
  }
};

export const updateOrganizationDetails = (data,setEditButton) => async (dispatch) => {
  dispatch({ type: "SHOW_UPLOAD_ORAGANIZATION" });
  try {
    await auction.put(`/profile/update/organization-name`, data);
    dispatch({ type: "HIDE_UPLOAD_ORAGANIZATION" });
    notifySuccess("Profile Updated Successfully");
    setEditButton(false);
    dispatch(getOrganizationDetails());
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_UPLOAD_ORAGANIZATION" });
  }
};
